export default [
    "24 24",
    '<path d="M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z" fill="none" stroke="var(--ci-primary-color, currentColor)" class="stroke-over" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<path d="M10.5 10.5L16 8L13.5 13.5L8 16L10.5 10.5Z" fill="none" stroke="var(--ci-primary-color, currentColor)" class="stroke-over"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']

